import styled from "styled-components";

const TextComponent = styled.p`
    font-family: ${props => props.fontFamily};
    font-size: ${props => props.fontSize};
    color: ${props => props.color};
    text-align: ${props => props.textAlign};
    /* word-break: break-all; */
    /* word-wrap: break-word; */
    justify-self: start;
    align-self: start;
    max-width: 1200px;
    margin: 0 auto;
    white-space: normal;
    margin-top: ${props => props.marginTop};
`
export const Text = (props)=>{
    return (
        <TextComponent 
            textAlign={props.textAlign}
            marginTop={props.marginTop}
            fontFamily={props.fontFamily}
            fontSize={props.fontSize}
            color={props.color}>
            {props.text}
        </TextComponent>
    )
}